import Vue from 'vue'

export const namespaced = true

export const state = {
  guestRoomChiefTypologies: [],
  countries: [],
  country: null,
  regions: [],
  cities: [],
  city: null,
  identificationDocuments: [],
  phonePrefixes: [],
  invoiceAccountTypes: [
    {
      id: 2,
      name: 'Ospite Persona Fisica',
      code: 'PF',
      description: 'Ospite Persona Fisica',
    },
    {
      id: 3,
      name: 'Ospite Persona Giuridica',
      code: 'PG',
      description: 'Ospite Persona Giuridica',
    }
  ],
}

export const mutations = {
  SET_COUNTRIES(state, countries) {
    state.countries = countries
  },
  SET_CITIES(state, cities) {
    state.cities = cities
  },
  SET_CITY(state, city) {
    state.city = city
  },
  SET_IDENTIFICATION_DOCUMENTS(state, identificationDocuments) {
    state.identificationDocuments = identificationDocuments
  },
  SET_GUEST_ROOM_CHIEF_TYPOLOGIES(state, guestRoomChiefTypologies) {
    state.guestRoomChiefTypologies = guestRoomChiefTypologies
  },
  SET_PHONE_PREFIXES(state, phonePrefixes) {
    state.phonePrefixes = phonePrefixes
  },
}

export const actions = {
  fetchCountries({ commit, dispatch, rootState }, searchAttrs) {
    let url = `${rootState.application.urls.countries_index}?`
    let urlParams = []
    if (!!searchAttrs.name) urlParams.push(`name=${searchAttrs.name}`)
    if (!!searchAttrs.id) urlParams.push(`id=${searchAttrs.id}`)
    if (window.sessionStorage.getItem('guestLocale')) urlParams.push(`locale=${window.sessionStorage.getItem('guestLocale')}`)
    url = `${url}${urlParams.join('&')}`

    return Vue.http.get(url, null, {
      responseType: 'json',
    }).then(response => {
      const countries = response.data
      commit('SET_COUNTRIES', countries)
      return countries
    }).catch(error => {
      // console.log('fetchCountries There was an error:', error.response ? error.response : error)
      return error
    })
  },
  fetchPhonePrefixes({ commit, rootState }, searchAttrs) {
    let url = `${rootState.application.urls.phone_prefixes}?`
    let urlParams = []
    if (!!searchAttrs.name) urlParams.push(`name=${encodeURIComponent(searchAttrs.name)}`)
    if (!!searchAttrs.id) urlParams.push(`id=${encodeURIComponent(searchAttrs.id)}`)
    url = `${url}${urlParams.join('&')}`

    return Vue.http.get(url, null, {
      responseType: 'json',
    }).then(response => {
      const phone_prefixes = response.data
      commit('SET_PHONE_PREFIXES', phone_prefixes)
      return phone_prefixes
    }).catch(error => {
      // console.log('fetchPhonePrefixes There was an error:', error.response ? error.response : error)
      return error
    })
  },
  fetchCities({ commit, dispatch, rootState }, searchAttrs) {
    let url = `${rootState.application.urls.cities_index}?`
    let urlParams = []
    if (!!searchAttrs.name) urlParams.push(`name=${searchAttrs.name}`)
    if (!!searchAttrs.id) urlParams.push(`id=${searchAttrs.id}`)
    if (!!searchAttrs.country_id) urlParams.push(`country_id=${searchAttrs.country_id}`)
    if (window.sessionStorage.getItem('guestLocale')) urlParams.push(`locale=${window.sessionStorage.getItem('guestLocale')}`)
    url = `${url}${urlParams.join('&')}`

    return Vue.http.get(url, null, {
      responseType: 'json',
    }).then(response => {
      const cities = response.data
      commit('SET_CITIES', cities)
      return cities
    }).catch(error => {
      // console.log('fetchCities There was an error:', error.response ? error.response : error)
      return error
    })
  },
  fetchCity({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      let city = getters.getCityById(id)
      if (city) {
        commit('SET_CITY', city)
        resolve(city)
      } else {
        reject(`city id ${id} not found`)
        // TODO fetch city from the db
      }
    })
  },
  fetchIdentificationDocuments({ commit, dispatch, rootState }, {isUe = null}) {
    // dispatch('layout/set_loading', true, { root: true })
    let url = rootState.application.urls.identification_documents_index
    if (isUe == false) {
      url += `?extra_ue=true`
    }
    Vue.http.get(url, null, {
      responseType: 'json',
    }).then(response => {
      const identificationDocuments = response.data
      commit('SET_IDENTIFICATION_DOCUMENTS', identificationDocuments)
      // dispatch('layout/set_loading', false, { root: true })
      return identificationDocuments
    }).catch(error => {
      // dispatch('layout/set_loading', false, { root: true })
      // console.log('fetchIdentificationDocuments There was an error:', error.response ? error.response : error)
      return error
    })
  },
  clearIdentificationDocuments({ commit }) {
    return new Promise((resolve, reject) => {
      commit('SET_IDENTIFICATION_DOCUMENTS', [])
      resolve([])
    })
  },
  fetchGuestRoomChiefTypologies({ commit, dispatch, rootState }) {
    // dispatch('layout/set_loading', true, { root: true })
    let url = rootState.application.urls.guest_room_chief_typologies
    return Vue.http.get(url, null, {
      responseType: 'json',
    }).then(response => {
      const guestRoomChiefTypologies = response.data
      commit('SET_GUEST_ROOM_CHIEF_TYPOLOGIES', guestRoomChiefTypologies)
      // dispatch('layout/set_loading', false, { root: true })
      return guestRoomChiefTypologies
    }).catch(error => {
      // dispatch('layout/set_loading', false, { root: true })
      // console.log('fetchGuestRoomChiefTypologies There was an error:', error.response ? error.response : error)
      return error
    })
  },
  fetchCoherentMemberTypology({ rootState }, roomChiefTypology) {
    const url = `${rootState.application.urls.coherent_member_typology}?room_chief_typology=${roomChiefTypology}`
    return Vue.http.get(url, null, {
      responseType: 'json',
    }).then(response => {
      const { memberTypology } = response.body
      return memberTypology
    }).catch(error => {
      return error
    })
  },
}


const GUEST_TYPOLOGIES = {
  SINGLE: 'SINGLE',
}

export const getters = {
  getGuestRoomChiefTypologies: state => guestCount => {
    // console.log(`getters/getGuestRoomChiefTypologies count ${guestCount}`, state.guestRoomChiefTypologies)
    let validGuestRoomChiefTypologies = state.guestRoomChiefTypologies
    if (validGuestRoomChiefTypologies.length == 0) { return [] }

    if (guestCount == 1) {
      validGuestRoomChiefTypologies = validGuestRoomChiefTypologies.filter(t => t.id == GUEST_TYPOLOGIES.SINGLE)
    } else if (guestCount > 1) {
      validGuestRoomChiefTypologies = validGuestRoomChiefTypologies.filter(t => t.id != GUEST_TYPOLOGIES.SINGLE)
    }
    // console.log(' - ', validGuestRoomChiefTypologies)
    return validGuestRoomChiefTypologies.map((typology) => {
      return { text: window.uiApp.$i18n.t(`guest.attributes.typologies_friendly.${typology.id.toLowerCase()}`),
        value: typology.id
      }
    })
  },
  getInvoiceAccountTypeByType: state => account_type => {
    if (!account_type) return {}
    const code = account_type == 'NATURAL' ? 'PF' : 'PG'
    const res = state.invoiceAccountTypes.find(iat => iat.code === code)
    // console.log(`getInvoiceAccountTypeByType ${account_type} ${res}`)
    return res
  },
  getCityById: state => id => {
    return state.cities.find(city => city.id === id)
  },
}
